import React, {useEffect} from "react";
import {appCtx, useFetchData} from "../app/AppContext";
import {getPct, MS_MIN} from "../tools/CommonJS";
import {UIProgressBar} from "../tools/UIStackedBar";
import {AnimateDivHeight} from "../tools/UIAnimateToggleDiv";
import {icn} from "../tools/UIIcons";
import {useRerender} from "../tools/CommonReact";
const dismissedReg = {};

export function ClientNotice({api, ktag, cond, condTemp, progress, title, msg, alt}) {
    const rerender = useRerender()
    const {rsp} = useFetchData({api, noErrMsg: true, noAutoFetch: dismissedReg[ktag], pollMs: 60 * MS_MIN, alt})
    const show = !dismissedReg[ktag] && rsp && (!condTemp || condTemp(rsp)) && (!cond || cond(rsp));

    useEffect(() => {
        if (!rsp || show || (condTemp && !condTemp(rsp)) || dismissedReg[ktag]) return;
        dismissedReg[ktag] = true;
        rerender();                     // if not showing, possibly rerender to reset polling.
    }, [rsp, show]);

    return <AnimateDivHeight className="bg-bg4/80 rounded-lg">
        {show &&
            <div className={`w-full bg-sec/10`}>
                <div className="flex items-center py-2 pl-8 pr-4 gap-4">
                    <div className="w-full cursor-pointer" onClick={() => appCtx.nav.to("/health", {}, {isReset: true})}>
                        <span className="text-sec text-base">{title}</span>&nbsp;
                        <span className="text-h2">{msg(rsp)}</span>
                    </div>
                    <div className="cursor-pointer" onClick={() => (dismissedReg[ktag] = true, rerender())}>{icn.remove35}<div/>
                    </div>
                </div>
                <UIProgressBar {...rsp && progress(rsp)} classNameBar="bg-sec/60 rounded-full" className="bg-bg3 border-none h-2 rounded-full"/>
            </div>}
    </AnimateDivHeight>;
}

export const ClientNoticeEOL = () =>
    <ClientNotice
        ktag="client-notice-eol"
        api="/api/v2/windows-agent-cert-end-of-life"
        cond={rsp => rsp.unsupportedDevices * 100 / rsp.totalDevices > 15}
        progress={rsp => ({val: rsp.unsupportedDevices, total: rsp.totalDevices})}
        title="Sensor update required:"
        msg={rsp =>
            `${getPct(rsp.unsupportedDevices, rsp.totalDevices, 0)} of your Windows devices are running a Sensor version prior to v2.39, which ${
                new Date() < new Date("09/01/2025")? "will": "has"
            } become obsolete on Sep-1-2025. Please ensure you have the proper Upgrade Batches in place.`}
        alt={{totalDevices: 10000, unsupportedDevices: 1000}}
    />;

export const ClientNoticeCIS = ({isOn}) =>
    <ClientNotice
        ktag="client-notice-cis"
        api="/api/v2/windows-agent-cert-end-of-life"
        cond={rsp => isOn && rsp.cisUnsupportedDevices * 100 / rsp.totalDevices > 15}
        condTemp={rsp => isOn}
        progress={rsp => ({val: rsp.cisUnsupportedDevices, total: rsp.totalDevices})}
        title="Sensor update required:"
        msg={rsp =>
            `${getPct(rsp.cisUnsupportedDevices, rsp.totalDevices, 0)} of your devices are running a Sensor version below v3.0.0, lacking support Custom CIS. Please update your sensors to the latest version.`}
        alt={{totalDevices: 10000, cisUnsupportedDevices: 1000}}
    />;
